import { render } from "./EmbedRibbon.vue?vue&type=template&id=05195cde"
import script from "./EmbedRibbon.vue?vue&type=script&lang=js"
export * from "./EmbedRibbon.vue?vue&type=script&lang=js"

import exportComponent from "/app/tmp/blackhall/V3/v2026.12.r1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__